import { render, staticRenderFns } from "./smartAnalyze.vue?vue&type=template&id=1331bbd3&scoped=true"
import script from "./smartAnalyze.vue?vue&type=script&lang=js"
export * from "./smartAnalyze.vue?vue&type=script&lang=js"
import style0 from "./smartAnalyze.vue?vue&type=style&index=0&id=1331bbd3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1331bbd3",
  null
  
)

export default component.exports